<script lang='ts' setup>
import type { ITrendingJobCategory } from '@/types/LP/trendingjob';


    const { $api } = useNuxtApp()
    const { isAuth } = useAuthStore()

    const { locale } = useI18n()
    const lang = locale.value as keyof MultiLang;
    
    interface MultiLang {
        en: string;
        id: string;
    }
    const authNote: Record<string, MultiLang> = {
        "title": {
            "en": "Want to see based by your preferences?",
            "id": "Ingin melihat lowongan sesuai preferensi Anda?"
        },
        "link_text": {
            "en": "Login Now",
            "id": "Masuk Sekarang"
        }
    }

    const content = ref({
        title: { en: '', id: '' } as MultiLang,
        description: '',
        content: []
    })
    const isLoading = ref(false)
  

    const jobs = ref<ITrendingJobCategory[]>([])

    onMounted(() => {
        nextTick(async () => {
            isLoading.value = true
            const { data: contentData } =
                await $api.landingPage.getLpTrendingJobsTitle()
            content.value = contentData.value.data

            const { data: trendingJobs } = await $api.landingPage.getFeaturedJobCategories()
            jobs.value = trendingJobs.value.data

            isLoading.value = false
        })
    })
</script>
<template>
    <section class="trending-job">
        <VContainer>
            <div class="trending-job__inner">
                <div class="trending-job__header">
                    <SectionTitle 
                        size="md"
                        align="center"
                        :title="content.title[lang]" 
                    />
                </div>
                <div class="trending-job__content">
                    <div v-if="isLoading" class="trending-job__listing">
                        <CardTrendingJobSkeleton v-for="n in 6" :key="n"/>
                    </div>
                
                    <div v-else class="trending-job__listing">
                        <div 
                            class="trending-job__item"
                            v-for="job in jobs" 
                            :key="job.name" 
                        >
                            <CardTrendingJob 
                                :data="job" 
                            />
                        </div>
                    </div>
                </div>
                 <VCard v-if="!isAuth" class="trending-job__note mt-8" flat>
                    <VCardText>{{ authNote.title[lang] }}
                        <NuxtLink
                            to="/login"
                            class="trending-job__login-link"
                            >{{ authNote.link_text[lang] }}</NuxtLink
                        >
                    </VCardText>
                </VCard>
            </div>
        </VContainer>
    </section>
</template>
<style lang='scss' scoped>
    .trending-job{
        background-color: #fff;
        position: relative;
        @include vwUnit('padding', 80 0 50, 42 0 42);
        &__header {
             @include vwUnit('margin-bottom', 38, 30);
        }

        &__listing {
            display: grid;
            grid-template-columns:repeat(3,1fr);
            @include vwUnit('gap',30,24);

            @media only screen and (max-width: 1199.98px) {
                grid-template-columns:repeat(2,1fr);
            }

            @media only screen and (max-width: 767.98px) {
                grid-template-columns:1fr;
            }
        }

        &__note{
            background-color: #FF1D250D;
            border-radius: 6px;
        }

        &__login-link {
            color: #C8102E;
            text-decoration: underline;
        }
    }
</style>
